import { Box } from '../../../../../../mads';
import { NewWindow } from '../../../../../../mads/icons';
import { Text } from '../../../../../../mads/Text';
import { useI18n } from '../../../../../../shared/I18n';
import { TextLink } from '../TextLink/TextLink';

import { StyleSheet } from 'react-native';

// Custom icon component with better alignment
const AlignedNewWindowIcon = (props: any) => (
    <Box sx={styles.iconContainer}>
        <NewWindow {...props} />
    </Box>
);

export function CompanyOverviewLink({
    companyName,
    companyOverviewLink,
    country,
}: {
    companyName?: string;
    companyOverviewLink?: string;
    isSimpleVjImproveActive: boolean;
    country: string;
}) {
    const i18n = useI18n();

    if (!companyOverviewLink) {
        return null;
    }

    if (country !== 'JP') {
        return (
            <TextLink
                iconAfter={<AlignedNewWindowIcon />}
                targetUrl={companyOverviewLink}
                variant={'strong'}
                aria-label={`${companyName} (${i18n.gettext('opens in a new tab')})`}
            >
                {companyName}
            </TextLink>
        );
    }

    return (
        <Text level={2}>
            <TextLink targetUrl={companyOverviewLink} variant={'neutral'}>
                {companyName}
            </TextLink>
        </Text>
    );
}

const styles = StyleSheet.create({
    iconContainer: {
        position: 'relative',
        top: 1, // Move icon down to align with text baseline
    },
});
